import { DropdownOption } from '@vibe/core';

export const SUPPORTED_LINE_ITEM_COLUMNS = [
  'date',
  'long_text',
  'text',
  'location',
  'numbers',
  'item_id',
  'phone',
  'email',
  'mirror',
  'formula',
  'status',
  'dropdown',
  'board_relation',
  'file',
  'link',
  'people',
];

export const TAX_TYPE_OPTIONS = [
  { value: 'percentage', label: 'Percentage' },
  { value: 'fixed', label: 'Fixed' },
];

export const MAX_ALLOWED_COLUMNS = 6;

export const SUBITEM_FILTER_CONDITIONS = {
  status: [
    {
      label: 'is',
      value: 'is',
    },
    {
      label: 'is not',
      value: 'is not',
    },
    {
      label: 'is empty',
      value: 'is empty',
    },
    {
      label: 'is not empty',
      value: 'is not empty',
    },
  ],
};

export const SUBITEM_FILTER_CHAINING: DropdownOption[] = [
  {
    label: 'And',
    value: 'AND',
  },
  {
    label: 'Or',
    value: 'OR',
  },
];

export const EMPTY_UNEMPTY_CONDITIONS = ['is empty', 'is not empty'];

export const CURRENCY_TYPE_OPTIONS = [
  { value: 'usd', label: 'USD', symbol: '$' },
  { value: 'gbp', label: 'GBP', symbol: '£' },
  { value: 'eur', label: 'EUR', symbol: '€' },
  { value: 'aud', label: 'AUD', symbol: 'AUD' },
  { value: 'cad', label: 'CAD', symbol: 'CAD' },
  { value: 'zar', label: 'ZAR', symbol: 'R' },
  { value: 'ils', label: 'ILS', symbol: '₪' },
];

export const CURRENCY_POSITION_OPTIONS = [
  { value: 'before', label: 'Before the value' },
  { value: 'after', label: 'After the value' },
];


export const LINE_ITEM_PADDING_X_TO_PDF_PAGE = 48;

export const DEFAULT_LINE_ITEM_HEADER_COLOR = '#F5F6F8';
